<template>
    <div>
        <div
            v-if="shown"
            :class="{ hide: !shown, show: shown }"
            class="ViewerNotice"
        >
            {{ text }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'ViewerNotice',
    data: function() {
        return { shown: false, text: '' }
    },
    methods: {
        randomIntFromInterval: function(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min)
        },
    },
    mounted: function() {
        let self = this
        let uur_geleden_geboekt = 0
        let aantal_op_pagina = 0

        let hour = new Date().getHours()
        let kans_show = this.randomIntFromInterval(1, 2)
        let kans_show2 = this.randomIntFromInterval(1, 6)

        if (kans_show == 1) {
            if (hour < 9) {
                aantal_op_pagina = this.randomIntFromInterval(0, 3)
            } else {
                aantal_op_pagina = this.randomIntFromInterval(5, 15)
            }
            if (aantal_op_pagina > 0) {
                this.text =
                    'Er zijn op dit moment ' +
                    aantal_op_pagina +
                    ' personen die deze cruise bekijken! '
                this.shown = true
            }
        }

        if (kans_show2 == 1) {
            if (hour > 9 && hour < 21) {
                uur_geleden_geboekt = this.randomIntFromInterval(1, 4)
            } else if (hour >= 21 && hour <= 23) {
                uur_geleden_geboekt = this.randomIntFromInterval(2, 4)
            }
            if (uur_geleden_geboekt > 0) {
                this.text +=
                    ' ' +
                    uur_geleden_geboekt +
                    ' uur geleden vond de meest recente boeking van deze cruise plaats.'
                this.shown = true
            }
        }

        if (this.shown)
            setInterval(function() {
                self.shown = false
            }, 7000)
    },
}
</script>

<style scoped>
.ViewerNotice {
    overflow: hidden;
    background: rgb(87, 183, 226)
        url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAoCAYAAAAPOoFWAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPZJREFUeNq81tsOgjAMANB2ov7/7ypaN7IlIwi9rGuT8QSc9EIDAsAznxvY4pXPKr05RUE5MEVB+TyWfCEl9LZApYopCmo9C4FKSMtYoI8Bwv79aQJU4l6hXXCZrQbokJEksxHo9KMOgc6w1atHXM8K9DVC7FQnJ0i8iK3QooGgbnyKgMDygBWyYFZoqx4qS27KqLZJjA1D0jK6QJcYEQEiWv9PGkTsbqxQ8oT+ZtZB6AkdsJnQDnMoHXHLGKOgDYuCWmYhEERCI5gaamW0bnHdA3k2ltlIN+2qKRyCND0bhqSYCyTB3CAOc4WusBEIpkeBuPgJMAAX8Hs1NfqHRgAAAABJRU5ErkJggg==)
        repeat-x scroll left top;
    border-radius: 5px;
    border: 1px solid rgb(11, 144, 196);
    box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
    color: rgb(255, 255, 255);
    width: 310px;
    height: auto;
    bottom: 20px;
    right: 20px;
    padding: 5px;
    position: fixed;
    z-index: 10000000;
    text-align: center;
}
</style>
